export const MODAL_CONTAINER_ID = 'modal-container';

export const COMPONENT_SENDER = {
  CONFIRM_PASSENGERS: 'CORE_ConfirmPassengers',
  RECENT_SEARCHES: 'CORE_RecentSearches'
} as const;
export type ComponentSenderKey = keyof typeof COMPONENT_SENDER;
export type ComponentSender = (typeof COMPONENT_SENDER)[ComponentSenderKey];

export const FLIGHT_DIRECTION = {
  INBOUND: 'Inbound',
  OUTBOUND: 'Outbound'
} as const;
export type FlightDirectionKeys = keyof typeof FLIGHT_DIRECTION;

export const FLIGHT_NUMBER_PARAMS = {
  DEPARTURE: 'xdfn',
  RETURN: 'xrfn'
} as const;
export type FlightNumberParamsKeys = keyof typeof FLIGHT_NUMBER_PARAMS;

export const PAX_PARAMS = {
  ADULTS: 'apax',
  CHILDREN: 'cpax',
  INFANTS: 'ipax'
};

export const DATE_PARAMS = {
  DEPARTURE: 'dd',
  RETURN: 'rd'
} as const;

export const FARE_CLASS_PARAM = {
  FARE: 'fare'
};

export const BUNDLE_IN_DEEPLINK = 'bundleInDeeplink';

export const PASSENGER_ID_PAIRINGS = 'passengerIdPairings';

export const CONFIRM_PASSENGERS_PARAM = 'spnl';

export const BUNDLE_ITEM_TYPE_LOYALTY = 'Loyalty';
